import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countdown", "questionContainer", "form", "timer", "submitButton", "option"]
  static values = {
    questionId: String,
    answerUrl: String,
    indexUrl: String
  }

  connect() {
    console.log("Hello from the Trivia Game Controller!", this.element);
    this.startCountdown();
  }

  startCountdown() {
    let count = 3
    this.countdownTarget.textContent = count
    this.countdownTarget.classList.remove("d-none")
    this.questionContainerTarget.classList.add("d-none")

    const countdownInterval = setInterval(() => {
      count--
      if (count > 0) {
        this.countdownTarget.textContent = count
      } else {
        clearInterval(countdownInterval)
        this.showQuestion()
      }
    }, 1000)
  }

  showQuestion() {
    this.countdownTarget.classList.remove("d-block");
    this.countdownTarget.classList.add("d-none");

    this.questionContainerTarget.classList.remove("d-none");
    this.questionContainerTarget.classList.remove("d-block");
    this.startTimer()
  }

  startTimer() {
    this.startTime = Date.now()
    this.timerInterval = setInterval(() => {
      const elapsed = (Date.now() - this.startTime) / 1000
      this.timerTarget.textContent = `Time: ${elapsed.toFixed(1)}s`
    }, 100)
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    return (Date.now() - this.startTime) / 1000
  }

  selectOption(event) {
    // If clicking directly on the radio input, let the default behavior happen
    if (event.target.type === 'radio') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    // Find the closest container div with trivia-game-target='option'
    const optionContainer = event.target.closest('[trivia-game-target="option"]');

    // Get the radio input within this container
    const radio = optionContainer.querySelector('input[type="radio"]');

    radio.setAttribute('checked', true);
    radio.checked = true;
  }

  async submitAnswer(event) {
    event.preventDefault()

    const speed = this.stopTimer()
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = "Submitting...";

    const formData = new FormData(this.formTarget)
    formData.append('trivia_answer[speed]', speed)

    console.log(formData)

    try {
      const response = await fetch(this.answerUrlValue, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      const result = await response.json()

      if (response.ok) {
        this.showResult(result.correct, speed)
      } else {
        this.showError("Failed to submit answer. Please try again.")
      }
    } catch (error) {
      console.error('Error submitting answer:', error)
      this.showError("Network error. Please try again.")
    }
  }

  showResult(correct, speed) {
    const resultDiv = document.createElement('div')
    resultDiv.className = `alert ${correct ? 'alert-success' : 'alert-danger'} text-center`
    resultDiv.innerHTML = `
      <h3>${correct ? 'Correct!' : 'Incorrect!'}</h3>
      <p>You answered in ${speed.toFixed(1)} seconds</p>
      <p>Redirecting to trivia list...</p>
    `

    this.questionContainerTarget.innerHTML = ''
    this.questionContainerTarget.appendChild(resultDiv)

    setTimeout(() => {
      window.location.href = this.indexUrlValue
    }, 2000)
  }

  showError(message) {
    const errorDiv = document.createElement('div')
    errorDiv.className = 'alert alert-danger text-center'
    errorDiv.textContent = message

    this.questionContainerTarget.insertBefore(errorDiv, this.questionContainerTarget.firstChild)

    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.textContent = "Answer"
  }

  disconnect() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }
}
